/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { colorsDictionary } from '@utils/colorsDictionary';
import { translate } from '@utils/translations';
import { getTextureThumbnailUrl } from '@temp/core/utils';
import { Popover } from '@components/organisms/Popover';
import React from 'react';
import { ReactSVG } from 'react-svg';

import { useMediaQuery } from '@hooks/useMediaQuery';
import { smallScreen } from '@styles/constants';

import checkImg from 'images/check.svg';
import crossImg from 'images/cross.svg';
import * as S from './styles';
import { IProps } from './types';

const ENTER_KEY = 13;
const SPACE_KEY = 32;

export const ColorCheckbox: React.FC<IProps> = ({
  name,
  checked,
  value,
  onChange = (): null => null,
  tooltip = false,
  ...props
}: IProps) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [isSmallScreen] = useMediaQuery(`(max-width: ${smallScreen}px)`);

  const tooltipContent = (
    <span
      style={{
        backgroundColor: value.color || colorsDictionary[value.slug],
        backgroundImage: `url(${getTextureThumbnailUrl(value.slug)})`,
        backgroundSize: 'cover',
      }}
    >
      <ReactSVG src={checkImg} className="color-checkbox__icon-check" />
      <ReactSVG src={crossImg} className="color-checkbox__icon-cross" />
    </span>
  );

  return (
    <S.ColorCheckbox
      ref={ref}
      onClick={(evt) => {
        evt.preventDefault();
        onChange(evt);
        if (ref.current) {
          ref.current.blur();
        }
      }}
    >
      <S.Label>
        <input
          {...props}
          tabIndex={-1}
          type="checkbox"
          name={name}
          checked={checked}
          readOnly
        />
        <div
          ref={ref}
          tabIndex={0}
          onKeyDown={(evt) => {
            if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
              evt.preventDefault();
              onChange(evt);
            }
          }}
        >
          {tooltip && !isSmallScreen ? (
            <Popover
              triggers={['hint']}
              placement="top"
              overlay={translate(value, 'name').replace('_', ' ')}
            >
              {tooltipContent}
            </Popover>
          ) : (
            tooltipContent
          )}
        </div>
      </S.Label>
    </S.ColorCheckbox>
  );
};

ColorCheckbox.displayName = 'ColorCheckbox';
